export default __webpack_public_path__ + "static/media/quietOnTheSet.e1947b0c.mp3";